import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFileDownloadStyle0 = cosmosIconCss;

const CosmosIconFileDownload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFileDownload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'eeaec9f65177efea93d7c36baa6c706069202957', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3d364b3c9509737fa0d555895be5782884ea071e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1fa6fcfff96812a2513345fe0414b1bee81561ef', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3h7.91a.49.49 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35V18.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18a.5.5 0 0 1 .5-.5h2V8h-3a.5.5 0 0 1-.5-.5v-3H6.5V8a.48.48 0 0 1-.5.48h-.5A.48.48 0 0 1 5 8V3.5a.5.5 0 0 1 .5-.5ZM3 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5.3 2.83 2-2.15A.4.4 0 0 0 10 15H8.75v-2.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5V15H6a.4.4 0 0 0-.27.68l2 2.15a.4.4 0 0 0 .57 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFileDownloadStyle0; }
}, [1, "cosmos-icon-file-download", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-file-download"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-file-download":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFileDownload$1);
            }
            break;
    } });
}

const CosmosIconFileDownload = CosmosIconFileDownload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFileDownload, defineCustomElement };
